<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button
          type="primary"
          size="mini"
          plain
          icon="el-icon-circle-plus-outline"
          @click="drawer = true"
          >新增</el-button
        >
      </div>
    </div>
    <div class="page_table_box">
      <div class="school_table_box" style="height:100%">
        <el-table
          :data="tableData"
          class="table_box"
          :header-cell-style="{ background: '#E2EEFF', color: '#474859' }"
          height="100%"
        >
          <el-table-column label="序号" width="70" align="center" type="index">
          </el-table-column>
          <el-table-column
            prop="deviseSerialNumber"
            label="设备序列号"
            align="center"
          >
          </el-table-column>

          <el-table-column
            prop="addDeviceLocation"
            label="设备地址"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="addDeviceLocation"
            label="添加时间"
            align="center"
          >
            <template slot-scope="scope">
              {{ $Common.dateFormatDateTwo(scope.row.addTime) }}
            </template>
          </el-table-column>

          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="check(scope.row)"
                >报警信息</el-link
              >
              <el-divider direction="vertical"></el-divider>
              <el-link
                class="link_box"
                type="primary"
                :underline="false"
                @click="del(scope.row.id)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      title="新增设备"
      :visible.sync="drawer"
      :direction="'ltr'"
      :modal-append-to-body="false"
      size="30%"
      :wrapperClosable="false"
      :close-on-press-escape="false"
      :before-close="handleClose"
    >
      <el-form ref="form" label-width="150px">
        <el-form-item label="设备序列号">
          <el-input
            v-model.trim="addData.deviseSerialNumber"
            placeholder="请输入设备序列号"
          ></el-input>
        </el-form-item>
        <el-form-item label="设备地址">
          <el-input
            v-model.trim="addData.addDeviceLocation"
            placeholder="请输入设备地址"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addFaceDevice">添加</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <face-device-alert
      :selResize="selResize"
      :deviseSerialNumber="deviseSerialNumber"
    ></face-device-alert>
  </div>
</template>

<script>
import faceDeviceAlert from "./components/faceDeviceAlert";
export default {
  name: "",
  components: {
    faceDeviceAlert
  },
  props: {},
  data() {
    return {
      // 数据列表
      tableData: [],
      addData: {
        schoolId: this.$store.state.schoolId,
        deviseSerialNumber: "",
        addDeviceLocation: ""
      },
      selectedDataList: [],
      drawer: false,
      delId: "",
      deviseSerialNumber: "",
      selResize: 0
    };
  },
  created() {
    this.getFaceDevice();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    handleClose() {
      this.drawer = false;
      this.addData.deviseSerialNumber = "";
      this.addData.addDeviceLocation = "";
    },
    check(row) {
      this.deviseSerialNumber = row.deviseSerialNumber;
      this.selResize++;
    },
    async getFaceDevice() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getFaceDevice(req);
      if (res.code == 200) {
        this.tableData = res.data || [];
      } else if (res.code == 101) {
        this.tableData = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    async addFaceDevice() {
      if (this.addData.deviseSerialNumber == "") {
        this.$message("请输入设备序列号!");
        return;
      }
      if (this.addData.addDeviceLocation == "") {
        this.$message("请输入设备地址!");
        return;
      }
      let req = this.addData;
      let res = await this.$Http.addFaceDevice(req);
      if (res.code == 200) {
        this.handleClose();
        this.getFaceDevice();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    del(id) {
      this.delId = id;
      this.$confirm("确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.delFaceDevice();
        })
        .catch(() => {});
    },
    async delFaceDevice() {
      let req = {
        id: this.delId
      };
      let res = await this.$Http.delFaceDevice(req, true);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "删除成功!"
        });
        this.getFaceDevice();
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
